export default __webpack_public_path__ + "static/how-we-work-c5c329056a80b7236aea53b0ef1fe6e8.png";